export interface WinnersTotal {
  totalEur: string;
  winnersCount: string;
}

export interface WinnerType {
  mul?: number;
  userId: string;
  screenName: string;
  currency: string;
  win: number;
  megawin: boolean;
  group?: string;
}
export interface CurrencyInfo {
  // TODO: maybe add currency code here as well?
  symbol: string;
  digitsNumber: number;
  groupNumber: number;
  decimalSeparator: string;
  groupSeparator: string;
}

export interface WinResultType {
  amount: number;
  isMegaWin: boolean;
  updateTimestamp: number;
}

// TODO: strictly define what is game status and what possible values should it have
export enum GameStatus {
  AutoplayLeft = 'AutoplayLeft', // FIXME: not really a status, more like a message
  BetsAccepted = 'BetsAccepted',
  BetsClosed = 'BetsClosed',
  BetsRejected = 'BetsRejected',
  BonusRound = 'BonusRound',
  DealerWins = 'DealerWins',
  Dealing = 'Dealing',
  Drawing = 'Drawing',
  GameCancelled = 'GameCancelled',
  Green = 'Green',
  LastBets = 'LastBets',
  MegaMultipliers = 'MegaMultipliers',
  Multipliers = 'Multipliers',
  NotAllBetsAccepted = 'NotAllBetsAccepted',
  PlaceYourBets = 'PlaceYourBets',
  Push = 'Push',
  Result = 'Result',
  Shuffling = 'Shuffling',
  SumTo = 'SumTo',
  Tumbling = 'Tumbling',
  WaitForNextGame = 'WaitForNextGame',
  WelcomeMsg = 'WelcomeMsg', // FIXME: not really a status, more like a message
  YouWin = 'YouWin',
}

export interface DealerType {
  name: string;
  id: string | null;
}

export interface TableType {
  openTime: number;
}

export interface TableCloseNotifyType {
  tableId: string;
  duration: string;
}
